// src/components/pos/ProductGrid.jsx - 带图片显示版本
import React from 'react';
import { Package } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const ProductGrid = ({ products = [], onAddToCart }) => {
  const { language } = useApp();

  // 获取商品显示名称
  const getProductName = (product) => {
    switch (language) {
      case 'en':
        return product.name_en || product.name;
      case 'km':
        return product.name_km || product.name;
      default:
        return product.name;
    }
  };

  // 获取商品图片URL
  const getProductImage = (product) => {
    if (!product.image) {
      return null;
    }
    
    // 如果是完整URL,直接返回
    if (product.image.startsWith('http://') || product.image.startsWith('https://')) {
      return product.image;
    }
    
    // 如果是相对路径,拼接服务器地址
    // 假设图片服务器地址为 http://47.79.252.120:5000
    return `http://47.79.252.120:5000${product.image}`;
  };

  if (!products || products.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400">
        <Package className="w-16 h-16 mx-auto mb-4 opacity-50" />
        <p>
          {language === 'en' ? 'No products found' : 
           language === 'km' ? 'រកមិនឃើញទំនិញ' : 
           '暂无商品'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {products.map((product) => {
        const imageUrl = getProductImage(product);
        const productName = getProductName(product);
        
        return (
          <div
            key={product.id}
            onClick={() => onAddToCart && onAddToCart(product)}
            className="bg-white border rounded-xl p-3 hover:shadow-lg hover:border-blue-500 transition-all cursor-pointer group"
          >
            {/* 商品图片 */}
            <div className="aspect-square mb-3 bg-gray-100 rounded-lg overflow-hidden relative">
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt={productName}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  onError={(e) => {
                    // 图片加载失败时显示占位图标
                    e.target.style.display = 'none';
                    e.target.parentElement.querySelector('.fallback-icon').style.display = 'flex';
                  }}
                />
              ) : null}
              
              {/* 占位图标 */}
              <div 
                className={`fallback-icon absolute inset-0 flex items-center justify-center ${imageUrl ? 'hidden' : 'flex'}`}
              >
                <Package className="w-12 h-12 text-gray-300" />
              </div>

              {/* 库存预警标识 */}
              {product.stock <= product.min_stock && (
                <div className="absolute top-2 right-2 bg-red-500 text-white text-xs px-2 py-1 rounded">
                  {language === 'en' ? 'Low' : language === 'km' ? 'ទាប' : '低库存'}
                </div>
              )}
            </div>

            {/* 商品信息 */}
            <div className="space-y-1">
              {/* 商品名称 */}
              <h3 className="font-medium text-sm text-gray-800 line-clamp-2 min-h-[2.5rem]">
                {productName}
              </h3>
              
              {/* 辅助名称(其他语言) */}
              {language !== 'zh' && product.name && (
                <p className="text-xs text-gray-400 line-clamp-1">
                  {product.name}
                </p>
              )}

              {/* 价格和库存 */}
              <div className="flex items-center justify-between pt-2">
                <div className="text-blue-600 font-bold text-lg">
                  ¥{parseFloat(product.sale_price).toFixed(2)}
                </div>
                <div className={`text-xs ${
                  product.stock <= product.min_stock 
                    ? 'text-red-500' 
                    : 'text-gray-500'
                }`}>
                  {language === 'en' ? 'Stock' : language === 'km' ? 'ស្តុក' : '库存'}: {product.stock}
                </div>
              </div>

              {/* 条码 */}
              <div className="text-xs text-gray-400 truncate pt-1">
                {product.barcode}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductGrid;